import * as React from 'react';
import { useSelector } from 'react-redux';

import { Reliability } from '../../components/Reliability';
import { ReliableBlock } from '../../components/ReliableBlock';
import { getNewbuildingId, getIsReliable, getHasProblems, getProblems } from '../../selectors/newbuilding';
import { ReliabilityHousesContainer } from './ReliabilityHousesContainer';
import { trackReliableMoreClick } from '../../analytics/trackReliableJK';
import { ProblemsContent } from '../../components/ProblemsContent';

export function ReliableBlockContainer() {
  const isReliable = useSelector(getIsReliable);
  const hasProblems = useSelector(getHasProblems);
  const problems = useSelector(getProblems);
  const newbuildingId = useSelector(getNewbuildingId);

  const onReliableMoreLinkClick = React.useCallback(() => {
    trackReliableMoreClick(newbuildingId);
  }, [newbuildingId]);

  if (!isReliable && !hasProblems) {
    return null;
  }

  return (
    <ReliableBlock hasProblems={hasProblems}>
      {hasProblems ? (
        <ProblemsContent problems={problems} />
      ) : (
        <Reliability houses={<ReliabilityHousesContainer />} onReliableMoreLinkClick={onReliableMoreLinkClick} />
      )}
    </ReliableBlock>
  );
}
